import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import ReinforcementsView from './ReinforcementsView';

import { Creators as ReinforcementsCardsAction } from '../../../domain/useCases/reinforcements/getReinforcementsByCourseUseCase';
import { Creators as coursesReinforcementsActions } from '../../../domain/useCases/reinforcements/getCoursesWithReinforcementsUseCase';
import { Creators as ReinforcementSubscribeActions } from '../../../domain/useCases/reinforcements/subscribeUseCase';
import { Creators as ReinforcementUnsubscribeActions } from '../../../domain/useCases/reinforcements/unsubscribeUseCase';

import XCheckpointManager from '../../../core/managers/xcheckpointManager';

import constants from '../../constants';
import { LocationState } from './constants';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const ReinforcementsViewController = () => {
  const location = useLocation<LocationState>();
  const courseIdParam = location.state?.courseId ?? '';
  const [selectedCourse, setSelectedCourse] = useState(courseIdParam);
  const [courseIndex, setCourseIndex] = useState(0);
  const dispatch = useDispatch();
  const history = useHistory();

  const [loadReinforcements, setLoadReinforcements] = useState(false);

  const { isLoading: isLoadingCourses, data: courses } = useSelector(
    (state: any) => state.coursesWithReinforcements
  );
  const { isLoading: isLoadingReinforcements, data: ReinforcementCards } =
    useSelector((state: any) => state.getReinforcementsByCourse);

  const getReinforcementsByCourse = (courseId: string) => {
    dispatch(
      ReinforcementsCardsAction.getReinforcementsByCourse(
        courseId,
        ReinforcementCards?.subscriptions
      )
    );
  };

  const selectReinforcement = (id: string, courseId: string) => {
    history.push(`/servicios/refuerzo-academico/${id}`, { courseId });
  };

  useEffect(() => {
    XCheckpointManager.registerStart(
      `Refuerzos ${selectedCourse ? 'cursos' : 'inscritos'}`
    );
    getReinforcementsByCourse(selectedCourse);
    setLoadReinforcements(true);
  }, [selectedCourse]);

  useEffect(() => {
    GoogleAnalytics.writeLog('portal-services-reinforcements', 'services');
    dispatch(coursesReinforcementsActions.getCoursesWithReinforcements());
    dispatch(ReinforcementSubscribeActions.subscribeToReinforcementClear());
    dispatch(ReinforcementUnsubscribeActions.unsubscribeToReinforcementClear());
    setLoadReinforcements(true);
  }, []);

  useEffect(() => {
    if (loadReinforcements && !isLoadingCourses && !isLoadingReinforcements) {
      XCheckpointManager.registerEnd(
        `Refuerzos ${selectedCourse ? 'cursos' : 'inscritos'}`
      );
      setLoadReinforcements(false);
    }
  }, [isLoadingCourses, isLoadingReinforcements]);

  const goBackButton = () => {
    history.push('/servicios');
  };

  return (
    <ReinforcementsView
      courses={courses}
      isLoadingCourses={isLoadingCourses}
      isLoadingReinforcements={isLoadingReinforcements}
      selectReinforcement={selectReinforcement}
      reinforcementCards={ReinforcementCards}
      setSelectCourse={setSelectedCourse}
      selectedCourse={selectedCourse}
      goBackButton={goBackButton}
      selectIndex={setCourseIndex}
      courseIndex={courseIndex}
      subsectionHeader={constants.subsectionHeader}
    />
  );
};

export default ReinforcementsViewController;
